import { doDeleteProject, getSavedProjects } from "apis/xserverapi";
import { doCall } from "common/genericSaga";
import { parseJwt } from "helpers/parseJwt";
import { all, apply, call, put, takeEvery } from "redux-saga/effects";
import { oidc } from "services/oidcService";
import {
  deleteProjectSuccess,
  DELETE_PROJECT_REQUESTED,
  DELETE_PROJECT_REQUEST_FAILED,
  receiveSavedProjects,
  SAVED_PROJECTS_REQUESTED,
  SAVED_PROJECTS_REQUEST_FAILED
} from "./projectActions";

export function* doRequestSavedProjects(action, requestInfo) {
  const oidcManager = yield call(oidc.getOidcManager);
  const token = yield apply(oidcManager, oidcManager.getAccessToken);
  const jwt = parseJwt(token);
  const response = yield call(getSavedProjects, requestInfo, jwt.sub, action.pageNumber, action.pageSize);
  yield put(receiveSavedProjects(action.pageSize, action.pageNumber, response.Total, response.Items));
}

export function* doRequestDeleteProject(action, requestInfo) {
  yield call(doDeleteProject, requestInfo, action.id);
  yield put(deleteProjectSuccess(action.id));
}

export function* watchProject() {
  yield all([
    takeEvery(SAVED_PROJECTS_REQUESTED, doCall(doRequestSavedProjects, SAVED_PROJECTS_REQUEST_FAILED)),
    takeEvery(DELETE_PROJECT_REQUESTED, doCall(doRequestDeleteProject, DELETE_PROJECT_REQUEST_FAILED))
  ]);
}
